// extracted by mini-css-extract-plugin
export default {"person":"Person_person__5TUMd","name-wrapper":"Person_name-wrapper__RwnAo","name":"Person_name__DNME6","role":"Person_role__x1FzZ"};